export function getAccountIdFromAccessToken(
  accessToken: string | null,
): number | null {
  const payload = decodeAccessTokenPayload(accessToken);
  const rawSubject = payload?.sub;
  const normalizedSubject =
    typeof rawSubject === 'string' && rawSubject.startsWith('sw:')
      ? rawSubject.slice('sw:'.length)
      : rawSubject;
  const accountId = Number(normalizedSubject);

  return Number.isSafeInteger(accountId) && accountId > 0 ? accountId : null;
}

export function getTenantIdFromAccessToken(
  accessToken: string | null,
): number | null {
  const payload = decodeAccessTokenPayload(accessToken);
  const tenantId = Number(payload?.tenantId);

  return Number.isFinite(tenantId) ? tenantId : null;
}

/**
 * 같은 계정으로 새 switch 세션을 시작해도 구분할 수 있는 세션 식별자.
 * BE가 switch access/refresh token pair에 동일한 jti를 넣으므로 토큰 회전 뒤에도 유지된다.
 */
export function getTokenSessionFingerprint(
  token: string | null,
): string | null {
  const payload = decodeAccessTokenPayload(token);
  const subject = payload?.sub;
  const jwtId = payload?.jti;

  if (
    typeof subject !== 'string' ||
    subject.length === 0 ||
    typeof jwtId !== 'string' ||
    jwtId.length === 0
  ) {
    return null;
  }

  return `${subject}:${jwtId}`;
}

function decodeAccessTokenPayload(
  accessToken: string | null,
): Record<string, unknown> | null {
  if (!accessToken) return null;

  try {
    const [, payload] = accessToken.split('.');
    if (!payload) return null;

    const base64Payload = payload
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(payload.length / 4) * 4, '=');
    const decodedPayload =
      typeof atob === 'function'
        ? atob(base64Payload)
        : Buffer.from(base64Payload, 'base64').toString('utf8');
    return JSON.parse(decodedPayload) as Record<string, unknown>;
  } catch {
    return null;
  }
}
